var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":_vm.statusData.color,"small":"","dark":_vm.statusData.dark}},[_vm._v(" "+_vm._s(_vm.statusData.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }